var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ConfigEditor',{attrs:{"form-schema":_vm.formSchema,"form-data":_vm.formData,"config-key":_vm.configKey},on:{"save-config":function($event){return _vm.saveConfig()}}})}
var staticRenderFns = []

export { render, staticRenderFns }